var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm.showButtonLayout
        ? _c(
            "AppSection",
            { attrs: { number: _vm.root, title: "Pick a style" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "button-layout-wrapper mb-3 flex-wrap justify-content-center justify-content-md-start"
                },
                [
                  _c("div", { staticClass: "col-auto p-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.button.layout,
                          expression: "value.button.layout"
                        }
                      ],
                      attrs: { type: "radio", id: "button", value: "button" },
                      domProps: {
                        checked: _vm._q(_vm.value.button.layout, "button")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.value.button, "layout", "button")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "para-2", attrs: { for: "button" } },
                      [
                        _c("InlineSvg", {
                          attrs: { src: "/images/icons/ic-button.svg" }
                        }),
                        _vm._v(_vm._s(_vm.$t("Button")) + " ")
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-auto p-0" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.button.layout,
                          expression: "value.button.layout"
                        }
                      ],
                      attrs: { type: "radio", id: "callout", value: "callout" },
                      domProps: {
                        checked: _vm._q(_vm.value.button.layout, "callout")
                      },
                      on: {
                        change: function($event) {
                          return _vm.$set(_vm.value.button, "layout", "callout")
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "para-2", attrs: { for: "callout" } },
                      [
                        _c("InlineSvg", {
                          attrs: { src: "/images/icons/ic-callout.svg" }
                        }),
                        _vm._v(_vm._s(_vm.$t("Callout")) + " ")
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.showPreview
                    ? _c("div", { staticClass: "col-auto p-0" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.value.button.layout,
                              expression: "value.button.layout"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            id: "proview",
                            value: "preview"
                          },
                          domProps: {
                            checked: _vm._q(_vm.value.button.layout, "preview")
                          },
                          on: {
                            change: function($event) {
                              return _vm.$set(
                                _vm.value.button,
                                "layout",
                                "preview"
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { staticClass: "para-2", attrs: { for: "proview" } },
                          [
                            _c("InlineSvg", {
                              attrs: { src: "/images/icons/ic-video.svg" }
                            }),
                            _vm._v(_vm._s(_vm.$t("Preview")) + " ")
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "AppSection",
        { attrs: { number: _vm.root + 1, title: "Select image" } },
        [
          _c("FileDropZone", {
            staticClass: "new",
            attrs: {
              image: _vm.value.button.image,
              userflowKey: _vm.userflowKey,
              "drop-zone-class": "header-image-drop-zone",
              "drop-zone-placeholder": "Thumbnail",
              "expected-dimension": "400x400",
              "data-test-id": "upload-button-file-button",
              "crop-aspect-ratio": 1,
              accept: "image"
            },
            on: {
              "start-upload": payload => _vm.$emit("start-upload", payload),
              uploaded: payload => _vm.$emit("imageUploaded", payload),
              "uploaded-all": payload => _vm.$emit("uploaded-all", payload),
              "delete-file": payload => _vm.$emit("delete-file", payload),
              "cancel-file": payload => _vm.$emit("cancel-file", payload)
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "AppSection",
        { attrs: { number: _vm.root + 2, title: "Add text" } },
        [
          _c("AppInput", {
            staticClass: "form-group mb-3 pb-2",
            class: { "form-error": _vm.validation.product.title.$error },
            attrs: {
              label: "Title",
              maxlength: "50",
              dataTestId: "title",
              placeholder: "Title Here...",
              required: ""
            },
            model: {
              value: _vm.value.product.title,
              callback: function($$v) {
                _vm.$set(_vm.value.product, "title", $$v)
              },
              expression: "value.product.title"
            }
          }),
          _vm._v(" "),
          ["callout", "preview"].includes(_vm.value.button.layout)
            ? _c(
                "div",
                [
                  _c("AppInput", {
                    staticClass: "form-group mb-3 pb-2",
                    attrs: {
                      label: _vm.$t("Subtitle"),
                      maxlength: "100",
                      dataTestId: "subtitle",
                      placeholder: _vm.$t(
                        "Enter a description for your followers here"
                      )
                    },
                    model: {
                      value: _vm.value.button.tagline,
                      callback: function($$v) {
                        _vm.$set(_vm.value.button, "tagline", $$v)
                      },
                      expression: "value.button.tagline"
                    }
                  }),
                  _vm._v(" "),
                  _c("AppInput", {
                    key: _vm.value.button.layout,
                    staticClass: "form-group mb-0",
                    class: {
                      "form-error": _vm.validation.button.button_text.$error
                    },
                    attrs: {
                      label: "Button*",
                      dataTestId: "button-text",
                      maxlength: "30",
                      placeholder: "Button Text Here..."
                    },
                    model: {
                      value: _vm.value.button.button_text,
                      callback: function($$v) {
                        _vm.$set(_vm.value.button, "button_text", $$v)
                      },
                      expression: "value.button.button_text"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }